
export async function checkPublicModeNotification() {
    const enabled = window.isPublicMode === true || window.PUBLIC_MODE === true || window.location.href.includes('public=true');
    if (enabled) await showPublicModeNotification();
}

export async function showPublicModeNotification() {
    try {
        let notificationContainer = $('#public-mode-notification');
        if (notificationContainer.length === 0) {
            notificationContainer = $('<div>', { id: 'public-mode-notification', class: 'alert alert-info alert-dismissible fade show', role: 'alert' });
            $('body').prepend(notificationContainer);
        }
        const content = getPublicModeNotificationContent();
        notificationContainer.html(content);
        if (notificationContainer.find('.btn-close').length === 0) {
            const closeButton = $('<button>', { type: 'button', class: 'btn-close', 'data-bs-dismiss': 'alert', 'aria-label': 'Close' });
            notificationContainer.append(closeButton);
        }
    } catch(_) {}
}

export function getPublicModeNotificationContent() {
    const lang = window.LANG || 'EN';
    const messages = {
        'RU': '🌐 Вы работаете в публичном режиме. Некоторые функции могут быть ограничены.',
        'EN': '🌐 You are in public mode. Some features may be limited.'
    };
    return messages[lang] || messages['EN'];
}


